/**
 * 国家 ISO-2 → 默认结算币种映射。单一事实源——所有 platform-master 主数据表单
 * （客户 / 供应商 / 合作伙伴 / 位置）公用，避免漂移（旧实现里 customers 有 JP，
 * suppliers 漏了 JP，导致同一客户从供应商页推算和从客户页推算不一致）。
 */
const COUNTRY_TO_CURRENCY: Record<string, string> = {
  CN: 'CNY',
  US: 'USD',
  AE: 'AED',
  DE: 'EUR',
  GB: 'GBP',
  JP: 'JPY',
  FR: 'EUR',
  IT: 'EUR',
  ES: 'EUR',
  KR: 'KRW',
  SG: 'SGD',
  HK: 'HKD',
  TW: 'TWD',
  AU: 'AUD',
  CA: 'CAD',
};

export function countryToCurrency(country?: string | null): string | undefined {
  if (!country) return undefined;
  return COUNTRY_TO_CURRENCY[String(country).toUpperCase()];
}
